import { useMutation, useQueryClient } from "@tanstack/react-query";
import galleriesMediaAPI from "../../api/galleries-media/api";

export function useDeleteGalleryMedia() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: galleriesMediaAPI.deleteGalleryMedia,
    onSuccess: (data, variables) => {
      // Invalidate and refetch galleries media list
      queryClient.invalidateQueries({ queryKey: ["galleries-media"] });
    },
    onError: (error) => {
      console.error("Delete gallery media failed:", error);
    },
  });
}
